/** The query parameter that hides the demo notice, for clean screenshots and videos. */
export const DEMO_CLEAN_PARAM = 'demo-clean';

/**
 * What `?demo-clean=` asks for: `true` hides the notice, `false` (`0` or `false`) shows it again,
 * `null` means the URL does not say.
 */
export function readDemoCleanParam(search: string): boolean | null {
  const value = new URLSearchParams(search).get(DEMO_CLEAN_PARAM);
  if (value === null) {
    return null;
  }
  return value !== '0' && value !== 'false';
}

export interface DemoNoticeInput {
  /** True while the active artist is the demo artist. */
  isDemoActive: boolean;
  /** `location.search` of the current page. */
  search: string;
  /** True when `?demo-clean=1` was seen earlier in this browser session. */
  isCleanForSession: boolean;
  /** True when the user closed the notice in this browser session. */
  isDismissed: boolean;
}

/**
 * design: music24-demo-artist a2/a6. The notice shows while the demo is active, unless the user
 * closed it in this session or the page is in clean mode. The URL wins over the session flag, so
 * `?demo-clean=0` shows the notice again.
 */
export function shouldShowDemoNotice({
  isDemoActive,
  search,
  isCleanForSession,
  isDismissed,
}: DemoNoticeInput): boolean {
  if (!isDemoActive || isDismissed) {
    return false;
  }
  const fromUrl = readDemoCleanParam(search);
  const isClean = fromUrl ?? isCleanForSession;
  return !isClean;
}
